<template>
  <div>
    <div v-for="(item, index) in data" :key="index">
      <b-form-checkbox v-model="parceiro.naturezas_juridicas" :value="item.id">
        {{ item.nome }}
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data: () => ({}),

  computed: {
    ...mapState("parceiros", ["parceiro"]),
  },
  methods: {},
  created() {},
};
</script>

<style lang="scss"></style>
